/**
 * Pull the copy-variant id out of a tracking `extra` payload.
 *
 * `AffiliateImpression` and `AffiliateLink` both take an open
 * `extra: Record<string, unknown>` that callers spread into the PostHog event,
 * and `OfferCard` puts `variant_id` in it. The D1 beacon takes typed fields
 * instead, so this is the one place the loosely-typed property is narrowed
 * before it reaches a column.
 *
 * Dependency-free and its own module on purpose: both callers are client
 * components, and importing `copy-variants.ts` for this would drag zod into
 * their bundle for a five-line read.
 */
export function readVariantId(
	extra: Record<string, unknown> | undefined,
): string | undefined {
	const value = extra?.variant_id;
	return typeof value === "string" && value.length > 0 ? value : undefined;
}
